// extracted by mini-css-extract-plugin
export var readonly = "_h7-1";
export var star = "_h7-0";